import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import {createApp} from 'vue'
import {createPinia} from 'pinia'
import { initSentry } from './domain/sentry/sentry'

import App from './App.vue'
import router from './router'

const app = createApp(App)
initSentry(app)

app.use(createPinia())
app.use(router)



app.mount('#app')
